<div class="main-content" id="main-content">
   <section id="breadcrumbs">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <app-breadcrumb
                  [breadcrumbItems]="breadcrumbItems"
               ></app-breadcrumb>
            </div>
         </div>
      </div>
   </section>

   <section id="page">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div id="page-header">
                  <div id="page-title" class="row">
                     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h2>{{ curso.nome }}</h2>
                        <ul class="categories">
                           <li>
                              <strong>Eixo Tecnológico: </strong>
                              <a
                                 *ngIf="eixo"
                                 routerLink="/cursos/eixo-tecnologico"
                                 [queryParams]="{ id: curso.eixoTecnologicoId }"
                                 >{{ eixo.nome }}</a
                              >
                           </li>
                           <li>
                              <strong>Área Tecnológica: </strong>
                              <ng-container
                                 *ngIf="areaTecnologica; else semArea"
                              >
                                 <a
                                    [routerLink]="['/cursos/area']"
                                    [queryParams]="{
                                       areaId: areaTecnologica.id,
                                       eixoId: curso.eixoTecnologicoId
                                    }"
                                    >{{ areaTecnologica.nome }}</a
                                 >
                              </ng-container>
                              <ng-template #semArea>
                                 <span
                                    >O eixo tecnológico não possui divisão em
                                    áreas tecnológicas</span
                                 >
                              </ng-template>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div id="page-data-share" class="row">
                     <div
                        id="page-data"
                        class="col-xs-12 col-sm-8 col-md-8 col-lg-8"
                     ></div>
                     <div
                        id="page-share"
                        class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
                     >
                        <span>Compartilhe:</span>
                        <div class="share-buttons">
                           <a
                              title="Facebook"
                              class="br-button tertiary circle mr-3"
                              [href]="facebookShareUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-facebook-f"></i>
                           </a>
                           <a
                              title="X (Twitter)"
                              class="br-button tertiary circle mr-3"
                              [href]="twitterShareUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-x-twitter"></i>
                           </a>
                           <a
                              title="LinkedIn"
                              class="br-button tertiary circle mr-3"
                              [href]="linkedinShareUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-linkedin-in"></i>
                           </a>
                           <a
                              title="WhatsApp"
                              class="br-button tertiary circle mr-3"
                              [href]="whatsappShareUrl"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-whatsapp"></i>
                           </a>

                           <a
                              title="Copiar para área de transferência"
                              class="br-button tertiary circle mr-3 link-clipboard"
                              (click)="copyLink()"
                           >
                              <i *ngIf="!isCopied" class="fa-solid fa-link"></i>
                              <i *ngIf="isCopied" class="fa-solid fa-check"></i>
                           </a>

                           <a
                              title="Referência"
                              class="br-button tertiary circle mr-3"
                              (click)="abrirModal()"
                           >
                              <i class="fas fa-quote-right"></i>
                           </a>
                        </div>
                     </div>

                     <app-citacao-modal
                        [citacao]="citacao"
                        [linkSite]="linkSite"
                        [data]="date"
                     ></app-citacao-modal>
                  </div>
               </div>

               <div id="page-content">
                  <div class="row">
                     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <p>
                           <img
                              class="img-responsive"
                              src="assets/comprimidas/{{ eixo.id }}/{{
                                 curso.imagem
                              }}"
                              onerror="this.src='assets/comprimidas/default.jpg';"
                              alt="{{ curso.nome }}"
                           />
                        </p>
                        <!-- {{perfilProfissional}} -->
                        <h3>Perfil profissional de conclusão</h3>
                        <div
                           tabindex="0"
                           [innerHTML]="perfilProfissional | formatLista"
                        ></div>
                        <br />
                        <button
                           class="br-button primary dark-mode mr-3"
                           type="button"
                           (click)="expandir()"
                        >
                           {{ displayAll ? 'Expandir todos' : 'Retrair todos' }}
                        </button>

                        <h4>
                           <a
                              (click)="toggleCollapse(0)"
                              [attr.aria-expanded]="!isCollapsed[0]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[0]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[0]"
                              ></i>
                           </a>
                           Código Cine
                        </h4>
                        <div *ngIf="!isCollapsed[0]" class="collapse show">
                           <p
                              tabindex="0"
                              [innerHTML]="codCine | format | textToLink"
                           ></p>
                        </div>
                        <h4>
                           <a
                              (click)="toggleCollapse(2)"
                              [attr.aria-expanded]="!isCollapsed[2]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[2]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[2]"
                              ></i>
                           </a>
                           Carga Horária Mínima
                        </h4>

                        <div
                           *ngIf="!isCollapsed[2]"
                           class="collapse show"
                           [innerHTML]="
                              curso.cargaHoraria
                                 | formatCargaHoraria
                                 | textToLink
                           "
                        ></div>

                        <h4>
                           <a
                              (click)="toggleCollapse(3)"
                              [attr.aria-expanded]="!isCollapsed[3]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[3]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[3]"
                              ></i>
                           </a>
                           Pré-requisitos para Ingresso
                        </h4>

                        <div *ngIf="!isCollapsed[3]" class="collapse show">
                           <div
                              [innerHTML]="
                                 curso.preRequisitoIngresso
                                    | formatLista
                                    | textToLink
                              "
                           ></div>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(4)"
                              [attr.aria-expanded]="!isCollapsed[4]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[4]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[4]"
                              ></i>
                           </a>
                           Legislação Profissional
                        </h4>

                        <div *ngIf="!isCollapsed[4]" class="collapse show">
                           <div *ngIf="legislacoes; else legisMsg">
                              <div *ngFor="let legislacao of legislacoes">
                                 <a
                                    href="{{ legislacao.link }}"
                                    target="_blank"
                                    rel="noreferrer"
                                    tabindex="0"
                                 >
                                    {{ legislacao.nome }}
                                 </a>
                                 <p tabindex="0">
                                    {{ legislacao.descricao }}
                                 </p>
                              </div>
                           </div>
                           <ng-template #legisMsg>
                              <p tabindex="0">
                                 Regulamentação não identificada até a
                                 publicação desta edição.
                              </p>
                           </ng-template>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(5)"
                              [attr.aria-expanded]="!isCollapsed[5]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[5]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[5]"
                              ></i>
                           </a>
                           Itinerários Formativos
                        </h4>

                        <div *ngIf="!isCollapsed[5]" class="collapse show">
                           <div
                              tabindex="0"
                              [innerHTML]="
                                 itinerariosFormativos
                                    | formatItinerarioInformativo
                                    | textToLink
                              "
                           ></div>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(6)"
                              [attr.aria-expanded]="!isCollapsed[6]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[6]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[6]"
                              ></i>
                           </a>
                           Campo de Atuação
                        </h4>

                        <div *ngIf="!isCollapsed[6]" class="collapse show">
                           <div
                              tabindex="0"
                              [innerHTML]="
                                 campoAtuacao | formatLista | textToLink
                              "
                           ></div>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(7)"
                              [attr.aria-expanded]="!isCollapsed[7]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[7]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[7]"
                              ></i>
                           </a>
                           Ocupações CBO Associadas
                        </h4>

                        <div *ngIf="!isCollapsed[7]" class="collapse show">
                           <ng-container *ngIf="ocupacoesCbo; else cbo">
                              <div
                                 tabindex="0"
                                 [innerHTML]="
                                    ocupacoesCbo | format | textToLink
                                 "
                              ></div>
                           </ng-container>

                           <ng-template #cbo>
                              <p tabindex="0">
                                 Ocupações CBO associadas não identificadas até
                                 a publicação desta edição.
                              </p>
                           </ng-template>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(1)"
                              [attr.aria-expanded]="!isCollapsed[1]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[1]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[1]"
                              ></i>
                           </a>
                           Infraestrutura Mínima
                        </h4>

                        <div
                           *ngIf="!isCollapsed[1]"
                           class="collapse show"
                           tabindex="0"
                           [innerHTML]="
                              infraestruturaMinima | formatInfraestruturaMinima
                           "
                        ></div>

                        <h4>
                           <a
                              (click)="toggleCollapse(8)"
                              [attr.aria-expanded]="!isCollapsed[8]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[8]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[8]"
                              ></i>
                           </a>
                           Nomenclaturas Anteriores
                        </h4>

                        <div *ngIf="!isCollapsed[8]" class="collapse show">
                           <div
                              *ngIf="nomeclaturasAnteriores; else nomenclatura"
                           >
                              <div *ngFor="let curso of nomeclaturasAnteriores">
                                 <div [innerHTML]="curso.nome"></div>
                              </div>
                           </div>
                           <ng-template #nomenclatura>
                              <p tabindex="0">
                                 O curso não possui nomenclaturas anteriores.
                              </p>
                           </ng-template>
                        </div>

                        <h4>
                           <a
                              (click)="toggleCollapse(9)"
                              [attr.aria-expanded]="!isCollapsed[9]"
                           >
                              <i
                                 class="fas fa-chevron-down fa-lg"
                                 *ngIf="isCollapsed[9]"
                              ></i>
                              <i
                                 class="fas fa-chevron-up fa-lg"
                                 *ngIf="!isCollapsed[9]"
                              ></i>
                           </a>
                           Instituições Ofertantes
                        </h4>

                        <div *ngIf="!isCollapsed[9]" class="collapse show">
                           <p>
                              As instituições de ensino que ofertam esse curso
                              podem ser consultadas no sistema e-MEC. Você pode
                              visualizá-las
                              <a
                                 href="https://emec.mec.gov.br/emec/nova"
                                 target="blank"
                                 >clicando aqui</a
                              >
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</div>
